// ── Obsługiwane języki ────────────────────────────────────────
export type Lang = 'en' | 'pl' | 'de' | 'fr' | 'es';

export const LANGUAGES: { code: Lang; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'pl', label: 'PL' },
  { code: 'de', label: 'DE' },
  { code: 'fr', label: 'FR' },
  { code: 'es', label: 'ES' },
];

const LANG_KEY = 'pdd_lang';

export function loadLang(): Lang {
  const v = localStorage.getItem(LANG_KEY);
  return (LANGUAGES.some(l => l.code === v) ? v : 'en') as Lang;
}

export function saveLang(lang: Lang) {
  localStorage.setItem(LANG_KEY, lang);
}

// ── Słownik tłumaczeń ─────────────────────────────────────────

interface Translations {
  // LoginScreen
  loginSubtitle:  string;
  loginUsername:  string;
  loginPassword:  string;
  loginBtn:       string;
  loginLoading:   string;
  loginErrEmpty:  string;
  loginErrServer: string;
  // StartupScreen
  startupTitle:      string;
  startupNewProject: string;
  startupLoad:       string;
  startupLogout:     string;
}

const T: Record<Lang, Translations> = {
  en: {
    loginSubtitle:  'Log in to continue',
    loginUsername:  'Username',
    loginPassword:  'Password',
    loginBtn:       'Log in',
    loginLoading:   'Logging in…',
    loginErrEmpty:  'Enter login and password.',
    loginErrServer: 'Server connection error.',
    startupTitle:      'Welcome to PDD – select action',
    startupNewProject: 'Start a new project',
    startupLoad:       'Load a project',
    startupLogout:     'Logout',
  },
  pl: {
    loginSubtitle:  'Zaloguj się, aby kontynuować',
    loginUsername:  'Nazwa użytkownika',
    loginPassword:  'Hasło',
    loginBtn:       'Zaloguj',
    loginLoading:   'Logowanie…',
    loginErrEmpty:  'Podaj login i hasło.',
    loginErrServer: 'Błąd połączenia z serwerem.',
    startupTitle:      'Witaj w PDD – wybierz akcję',
    startupNewProject: 'Nowy projekt',
    startupLoad:       'Wczytaj projekt',
    startupLogout:     'Wyloguj',
  },
  de: {
    loginSubtitle:  'Melden Sie sich an, um fortzufahren',
    loginUsername:  'Benutzername',
    loginPassword:  'Passwort',
    loginBtn:       'Anmelden',
    loginLoading:   'Anmelden…',
    loginErrEmpty:  'Login und Passwort eingeben.',
    loginErrServer: 'Verbindungsfehler zum Server.',
    startupTitle:      'Willkommen bei PDD – Aktion wählen',
    startupNewProject: 'Neues Projekt starten',
    startupLoad:       'Projekt laden',
    startupLogout:     'Abmelden',
  },
  fr: {
    loginSubtitle:  'Connectez-vous pour continuer',
    loginUsername:  'Nom d\'utilisateur',
    loginPassword:  'Mot de passe',
    loginBtn:       'Se connecter',
    loginLoading:   'Connexion…',
    loginErrEmpty:  'Saisissez identifiant et mot de passe.',
    loginErrServer: 'Erreur de connexion au serveur.',
    startupTitle:      'Bienvenue dans PDD – choisir une action',
    startupNewProject: 'Démarrer un nouveau projet',
    startupLoad:       'Charger un projet',
    startupLogout:     'Se déconnecter',
  },
  es: {
    loginSubtitle:  'Inicie sesión para continuar',
    loginUsername:  'Nombre de usuario',
    loginPassword:  'Contraseña',
    loginBtn:       'Iniciar sesión',
    loginLoading:   'Iniciando sesión…',
    loginErrEmpty:  'Introduzca usuario y contraseña.',
    loginErrServer: 'Error de conexión con el servidor.',
    startupTitle:      'Bienvenido a PDD – seleccionar acción',
    startupNewProject: 'Iniciar nuevo proyecto',
    startupLoad:       'Cargar proyecto',
    startupLogout:     'Cerrar sesión',
  },
};

export function t(lang: Lang): Translations {
  return T[lang];
}
